import React, { Fragment, useEffect } from 'react';

import AWS from '../../../assets/images/aws-icon.png';
import AZURE from '../../../assets/images/azure-icon.png';
import GOOGLE from '../../../assets/images/googleCloud.png';
import { Controller, useForm } from 'react-hook-form';
import {
  Grid,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  Radio,
  Select,
  MenuItem,
  RadioGroup,
  FormLabel,
  FormControlLabel,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { accountService } from '../../../services';
import { DashboardHeader } from '../../../components/Header/DashboardHeader';
import useStyles from './CreateAccount.style';
import helperStyles from '../../../styles/helper.styles';
import { AccountProps } from '../../../schemas/account.schema';
import { RoutesFun } from '../../../schemas';
// import {
//   useUserData,
//   useUserDataActions,
// } from '../../../context/GlobalUserData';
import { Navigation } from '../../../components/Navigation/Navigation';
import { countries } from './Countries';
import { handleError } from '../../../utils/config';
import SelectionCard from './SelectionCard';
import AutomatedCard from './AutomatedCard';
import { uiState } from '../../../store';
import { useSelector } from 'react-redux';
import AwsAccountOnboarding from './ManualSections/ManualOnboarding';

interface AccountCreationProps {
  children?: React.ReactNode;
  match?: {
    params?: { string: number };
  };
  location?: {
    state?: { string: unknown };
  };
}

export const CreateAccountPage: React.FC<AccountCreationProps> = (props) => {
  const classes = useStyles();
  const Routes = RoutesFun();
  const helperClasses = helperStyles();
  const history = useHistory();
  const [isEdit, setIsEdit] = React.useState(false);
  const [back, setBack] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState([]);
  const [errmsgDisplay, seterrmsgDisplay] = React.useState('d-none');
  const [type, setType] = React.useState<any>({
    Name: '',
    CloudProvider: '',
    Location: '',
    PayeeOrganization: '',
    Attributes: '',
  });
  const [updateId, setUpdateId] = React.useState(0);
  const payeeTypes = [
    'Place new payees at hierarchy root',
    'Place new payees in same parent group as payer',
    'Place new payees in specific location',
  ];
  const [msg, setMsg] = React.useState(false);
  const [isNetworkError, setNetworkError] = React.useState(false);
  const [selectedCard, setSelectedCard] = React.useState<string | null>(null);
  const { collapsed } = useSelector(uiState);
  const removeSelectedCard = () => setSelectedCard(null);

  const {
    register,
    handleSubmit,
    control,
    formState,
    errors,
    setValue,
  } = useForm<AccountProps>({
    mode: 'onChange',
  });

  const cloudType = [
    { Id: 1, Name: 'AWS', ImageName: AWS },
    // { Id: 2, Name: 'AZURE', ImageName: AZURE },
    // { Id: 3, Name: 'GOOGLE', ImageName: GOOGLE },
  ];

  const handleChange = (
    event: React.ChangeEvent<{ name?: any; value: unknown }>
  ) => {
    setType((prevType: any) => {
      return {
        ...prevType,
        [event.target.name]: event.target.value,
      };
    });
  };

  // const getAllLocations = async () => {
  //   const result = await accountService.getLocations();
  //   setLocation(result);
  // };

  const checkIsEdit = () => {
    let param: any;

    if (props.match) {
      param = props.match.params;
    }
    if (Object.keys(param).length > 0) {
      if (param.Id) {
        getAccount(param.Id, param.cloudProvider);
      }
      setUpdateId(param.Id);
      setIsEdit(true);
    }
  };

  const checkIsBack = () => {
    if (props && props.location && props.location.state !== undefined) {
      setBack(true);
    }
  };

  const regMsgElement = () => {
    return <div className="regMsg">GOOGLE account is disabled</div>;
  };

  const onSubmit = async (data: AccountProps) => {
    try {
      if (type) {
        if (data.CloudProvider === 'GOOGLE') {
          setMsg(true);
        } else if (data.CloudProvider === 'AWS') {
          // setMsg(true);
          data.Name = type.Name;
          data.Attributes = type.Attributes;
          if (isEdit) {
            data.Id = updateId;
            const response = await accountService.editAccount(data);
            history.push(Routes.AccountDetails);
          } else {
            history.push({ pathname: Routes.ConfigureAccount, state: data });
            setBack(false);
          }
        } else {
          data.Name = type.Name;
          data.Attributes = type.Attributes;
          if (isEdit) {
            data.Id = updateId;
            const response = await accountService.editAccount(data);
            // toasterService.show(response.message, 'success');
            history.push(Routes.AccountDetails);
          } else {
            history.push({ pathname: Routes.ConfigureAccount, state: data });
            setBack(false);
          }
        }
      }
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        handleError(e, history);
        setErrorMsg(e.error.message.replace('ContactNo', 'Phone Number'));
        seterrmsgDisplay('d-block');
      }
      setTimeout(() => {
        seterrmsgDisplay('d-none');
      }, 2000);
    }
    // finally {
    //   setTimeout(() => {
    //     setmsgDisplay('d-none');
    //     seterrmsgDisplay('d-none');
    //   }, 2000);
    // }
  };

  const getAccount = async (Id: number, cloudProvider: string) => {
    const response = await accountService.getAccountData(Id, cloudProvider);
    setType(response);
  };

  useEffect(() => {
    checkIsEdit();
    checkIsBack();
  }, []);

  useEffect(() => {
    if (type && isEdit) {
      setValue('Name', type.Name);
      setValue('Location', type.Location);
      setValue('CloudProvider', type.CloudProvider);
      setValue('PayeeOrganization', type.PayeeOrganization);
      setValue('Attributes', type.Attributes);
    }
  }, [type]);

  // useEffect(() => {
  //   setCurrentPage(loc.pathname);
  // }, [loc]);

  useEffect(() => {
    if (type && isEdit) {
    } else if (props.location && props.location.state) {
      setType(props.location.state);
      setValue('Name', type.Name);
      setValue('Location', type.Location);
      setValue('CloudProvider', type.CloudProvider);
      setValue('PayeeOrganization', type.PayeeOrganization);
      setValue('Attributes', type.Attributes);
    }
  }, [props.location, back]);

  if (isNetworkError) {
    throw new Error('Network Error');
  }

  return (
    <Fragment>
      <DashboardHeader />
      {/* <Navigation /> */}
      <Grid container className="innerContainer">
        <div className="splitLayout">
          <div className={`leftNav ${collapsed ? 'collapsed' : ''}`}>
            <Navigation />
          </div>

          <div className="rightContent">
            <div className="innerRightContent">
              {selectedCard === null && (
                <div className="createAccountContainer">
                  <form
                    noValidate
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                  >
                    <div className="innerContainer">
                      <div className="sContainer mb-15">
                        <div className="inventoryHeading pl-5">
                          <span className="font-30px fw-300">
                            {isEdit
                              ? 'Edit Account'
                              : 'Onboard Your Cloud Account'}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="configureAccountForm">
                      <div className="w-100">
                        <Grid container>
                          <Grid item md={6} sm={6} xs={6} className="p-10">
                            <FormControl
                              variant="outlined"
                              className="mb-10 configureFormElement"
                            >
                              {isEdit ? (
                                <InputLabel
                                  id="demo-multiple-name-label"
                                  shrink={Boolean(type.Name)}
                                >
                                  CFx Name
                                </InputLabel>
                              ) : (
                                <InputLabel id="demo-multiple-name-label">
                                  CFx Name
                                </InputLabel>
                              )}
                              <OutlinedInput
                                id="Name1"
                                name="Name"
                                type="text"
                                inputRef={register({
                                  required: true,
                                  pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                                })}
                                defaultValue={type?.Name}
                                onChange={handleChange}
                                // MenuProps={MenuProps}
                              />
                              <span className={classes.warningMessage}>
                                {(formState.touched.Name &&
                                  type.Name.length === 0 &&
                                  'CFX Name is required') ||
                                  (errors.Name && 'Enter valid CFX Name')}
                              </span>
                            </FormControl>
                          </Grid>

                          {/*Hiding the non required input/select boxes for now in case needed for future use*/}
                          {selectedCard || selectedCard === null ? null : (
                            <Grid className="d-none">
                              <Grid item md={6} sm={6} xs={6} className="p-10">
                                <FormControl
                                  variant="outlined"
                                  className="mb-10 configureFormElement w-100"
                                >
                                  <InputLabel id="CloudProvider1">
                                    CLOUD PROVIDER
                                  </InputLabel>
                                  <Controller
                                    name="CloudProvider"
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue={
                                      type.CloudProvider
                                        ? type.CloudProvider
                                        : ''
                                    }
                                    render={({ onChange, name, value }) => (
                                      <Select
                                        label="CloudProvider"
                                        onChange={onChange}
                                        name={name}
                                        value={value}
                                      >
                                        {cloudType.map((item: any) => (
                                          <MenuItem
                                            key={item.Id}
                                            value={item.Name}
                                          >
                                            {item.Name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    )}
                                  />

                                  <span className={classes.warningMessage}>
                                    {errors?.CloudProvider &&
                                      'CloudProvider is required'}
                                  </span>
                                </FormControl>
                              </Grid>
                              <Grid item md={6} sm={6} xs={6} className="p-10">
                                <FormControl
                                  variant="outlined"
                                  className="mb-10 configureFormElement w-100"
                                >
                                  <InputLabel id="Location1">
                                    LOCATION
                                    {/* <span className={helperClasses.styleFont}>
                                    Clear this field to move account to the root
                                  </span> */}
                                  </InputLabel>
                                  <Controller
                                    name="Location"
                                    rules={{ required: true }}
                                    control={control}
                                    onChange={handleChange}
                                    defaultValue={
                                      type.Location ? type.Location : ''
                                    }
                                    render={({ onChange, name, value }) => (
                                      <Select
                                        label="Location"
                                        name={name}
                                        onChange={onChange}
                                        value={value}
                                        MenuProps={{
                                          classes: { paper: classes.menuPaper },
                                        }}
                                      >
                                        {countries.map((item: any, i: any) => (
                                          <MenuItem key={i} value={item.label}>
                                            {item.label}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    )}
                                  />
                                  <span className={classes.warningMessage}>
                                    {errors.Location && 'Location is required'}
                                  </span>
                                </FormControl>
                              </Grid>
                              <Grid item md={6} sm={6} xs={6} className="p-10">
                                <FormControl
                                  variant="outlined"
                                  className="mb-10 configureFormElement w-100"
                                >
                                  <InputLabel id="PayeeOrganization1">
                                    PAYEE ORGANISATION
                                    <span className={helperClasses.styleFont}>
                                      (Only applicable if account is Payer)
                                    </span>
                                  </InputLabel>
                                  <Controller
                                    name="PayeeOrganization"
                                    rules={{ required: true }}
                                    control={control}
                                    onChange={handleChange}
                                    defaultValue={
                                      type.PayeeOrganization
                                        ? type.PayeeOrganization
                                        : ''
                                    }
                                    render={({ onChange, name, value }) => (
                                      <Select
                                        label="PayeeOrganization"
                                        onChange={onChange}
                                        name={name}
                                        value={value}
                                      >
                                        {payeeTypes.map((item) => (
                                          <MenuItem key={item} value={item}>
                                            {item}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    )}
                                  ></Controller>
                                  <span className={classes.warningMessage}>
                                    {errors.PayeeOrganization &&
                                      'PayeeOrganization is required'}
                                  </span>
                                </FormControl>
                              </Grid>
                              <Grid item md={6} sm={6} xs={6} className="p-10">
                                <FormControl
                                  variant="outlined"
                                  className="mb-20 configureFormElement"
                                >
                                  <InputLabel
                                    id="demo-mutiple-name-label"
                                    shrink={Boolean(type.Attributes)}
                                  >
                                    ATTRIBUTES
                                  </InputLabel>
                                  <OutlinedInput
                                    id="Attributes1"
                                    name="Attributes"
                                    type="text"
                                    inputRef={register}
                                    defaultValue={type?.Attributes}
                                    onChange={handleChange}
                                  ></OutlinedInput>
                                </FormControl>
                              </Grid>
                            </Grid>
                          )}

                          <Grid item md={12} sm={12} xs={12} className="p-10">
                            <FormControl className="mb-10 w-100">
                              <FormLabel
                                component="legend"
                                className="font-13px fw-500 exportLabel"
                              >
                                CLOUD PROVIDER
                              </FormLabel>
                              <RadioGroup
                                row
                                value={'AWS'}
                                // onChange={(e) => setCloudName(e.target.value)}
                              >
                                {cloudType.map((option) => (
                                  <FormControlLabel
                                    key={option.Id}
                                    value={option.Name}
                                    control={
                                      <Radio style={{ display: 'none' }} />
                                    }
                                    label={
                                      <div
                                        aria-disabled
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          border:
                                            'AWS' === option.Name
                                              ? '2px solid #1976d2'
                                              : '2px solid transparent',
                                          borderRadius: '10px',
                                          padding: '10px',
                                          margin: '5px 0',
                                          transition: '0.3s ease',
                                          cursor: 'pointer',
                                        }}
                                      >
                                        <img
                                          src={option.ImageName}
                                          alt={option.Name}
                                          style={{
                                            width: '50px',
                                            height: 'auto',
                                            borderRadius: '5px',
                                          }}
                                        />
                                        <Typography>{option.Name}</Typography>
                                      </div>
                                    }
                                  />
                                ))}
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          <Grid
                            item
                            md={8}
                            sm={12}
                            xs={12}
                            className="p-10"
                            style={{ margin: '0 auto' }}
                          >
                            <FormControl className="mb-10 w-100">
                              <FormLabel
                                component="legend"
                                className="font-13px fw-500 exportLabel"
                              >
                                <Typography
                                  variant="h4"
                                  style={{
                                    marginBottom: 24,
                                    textAlign: 'center',
                                  }}
                                >
                                  Choose how would you like to configure CUR
                                </Typography>
                              </FormLabel>
                              <SelectionCard onSelect={setSelectedCard} />
                            </FormControl>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          md={12}
                          sm={12}
                          xs={12}
                          className="accountsMsg m-5 mx-10"
                        >
                          <div className="errMsg">
                            {msg ? regMsgElement() : ''}
                          </div>
                          <div
                            className={
                              errorMsg.length
                                ? 'alert-danger p-8 px-20 mr-10 font-14px responseMsg ' +
                                  errmsgDisplay
                                : ''
                            }
                          >
                            {errorMsg}
                          </div>
                        </Grid>
                        {/* <Grid container className="configureAccountBtns">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={cancel}
                          >
                            CANCEL
                          </button>

                          <button type="submit" className="btn btn-primary">
                            {isEdit ? 'UPDATE' : 'SAVE'}
                          </button>
                        </Grid> */}
                      </div>
                    </div>
                  </form>
                </div>
              )}
              {selectedCard === 'automated' && (
                <AutomatedCard onCancel={removeSelectedCard} />
              )}
              {selectedCard === 'manual' && (
                // <ManualCard onCancel={ removeSelectedCard } />
                <AwsAccountOnboarding />
              )}
            </div>
          </div>
        </div>
      </Grid>
    </Fragment>
  );
};
